import type { Catalog } from "../../en";

/** Filipino: source detail (/w/:ws/knowledge/:sourceId) (mirrors en). */
export const sourceDetail: Catalog["deployKnowledge"]["sourceDetail"] = {
  title: "Detalye ng source",
  back: "Bumalik sa Knowledge Base",
  usedBy: "Ginagamit ng",
  usedByNone: "Hindi pa naka-link sa anumang agent",
  and: "at",
  version: "v{{version}}",
  notFoundTitle: "Wala na ang source na ito",
  notFoundBody: "Maaaring nabura na ito. Bumalik sa Knowledge Base para makita ang kasalukuyang mga source.",
  loadError: "Hindi ma-load ang source na ito.",
  status: {
    ready: "Handa na",
    processing: "Pinoproseso",
    queued: "Nakapila",
    failed: "Nabigo",
    disabled: "Naka-disable",
    readyWithWarnings: "Handa na, may babala",
    processingPages: "Pinoproseso · {{done}}/{{total}} page",
  },
  stages: {
    uploading: "Nag-a-upload",
    parsing: "Pina-parse (OCR)",
    chunking: "Hinahati sa chunks",
    contextualizing: "Nilalagyan ng konteksto",
    embedding: "Ine-embed",
    ready: "Handa na",
    failed: "Nabigo",
  },
  types: {
    file: "File",
    website: "Website",
    qa: "Q&A",
    text: "Text snippet",
    drive: "Google Drive",
  },
  actions: {
    replace: "Palitan ang file",
    reindex: "I-re-index",
    reindexing: "Nire-re-index — mananatiling live ang kasalukuyang bersyon hanggang matapos",
    recrawling: "Naka-queue ang re-crawl — mananatiling live ang kasalukuyang mga page hanggang matapos",
    download: "I-download",
    delete: "Burahin",
  },
  details: {
    title: "Mga detalye",
    type: "Uri",
    pages: "Mga page",
    size: "Laki",
    url: "Address",
    version: "Bersyon",
    versionValue: "{{version}} · {{date}}",
    language: "Natukoy na wika",
    languageUnknown: "Hindi pa natutukoy",
    lastSynced: "Huling na-sync",
    validity: "May bisa",
    validityRange: "{{from}} – {{until}}",
    chunks: "Mga chunk",
    excluded: "({{count}} hindi kasama)",
    warnings: "Mga babala",
  },
  access: {
    title: "Kontrol sa access",
    inherit: "Sundin ang agent",
    inheritHint: "Gamitin ang default na audience ng bawat agent sa halip na nakapirming set.",
    inheritUnknown: "Kailangan mo ng access sa Audience at Access para baguhin ito.",
    who: "Sino ang puwedeng kumuha sa dokumentong ito",
    whoHint: "Sina-salà ang mga sagot ayon sa audience bago pa makita ng AI ang source na ito.",
    atLeastOne: "Pumili ng kahit isang audience",
    agentMapping: "{{agent}} → {{audiences}}",
    save: "I-save ang access",
    saved: "Na-save ang access — na-re-tag ang mga chunk nang hindi nire-re-embed",
    inheritOn: "Sinusunod na ng dokumentong ito ang audience ng bawat agent",
  },
  timeline: {
    title: "Timeline ng pagproseso",
    total: "v{{version}}",
    uploaded: "Na-upload",
    parsed: "Na-parse",
    chunked: "Nahati sa chunks",
    contextualized: "Nalagyan ng konteksto",
    embedded: "Na-embed",
    indexed: "Na-index",
    done: "Tapos",
    running: "Ginagawa",
    pending: "Naghihintay",
    failed: "Nabigo",
    live: "Naka-on ang live na update",
    polling: "Tinitingnan kung may update…",
    progress: "{{percent}}% tapos",
  },
  versions: {
    title: "Kasaysayan ng bersyon",
    current: "Kasalukuyang bersyon",
    live: "Live",
    chunks_one: "{{count}} chunk",
    chunks_other: "{{count}} na chunk",
    restore: "Ibalik",
    restoreLabel: "Ibalik ang bersyon {{version}}",
    restoring: "Ibinabalik ang v{{version}} — nire-re-index; mananatili ang live na bersyon hanggang matapos",
    empty: "Walang naunang bersyon",
  },
  tabs: {
    label: "Nilalaman ng source",
    chunks: "Mga chunk",
    preview: "Preview",
    questions: "Mga tanong na sinasagot nito",
    usage: "Paggamit",
  },
  chunks: {
    search: "Maghanap sa loob ng mga chunk…",
    view: "View ng chunk",
    all: "Lahat",
    excludedView: "Hindi kasama",
    page: "p. {{page}}",
    pages: "pp. {{from}}–{{to}}",
    tokens: "{{count}} tok",
    excludedBadge: "Hindi kasama",
    edited: "Na-edit",
    contextLabel: "Kontekstong idinagdag para sa retrieval",
    edit: "I-edit",
    editLabel: "I-edit ang chunk #{{n}}",
    exclude: "Huwag isama",
    excludeLabel: "Huwag isama ang chunk #{{n}}",
    include: "Isama",
    includeLabel: "Isama ang chunk #{{n}}",
    excludedToast: "Hindi na isasama ang chunk #{{n}} — hindi na ito kukunin",
    includedToast: "Isinama muli ang chunk #{{n}}",
    test: "Subukan sa Playground",
    showing: "Ipinapakita ang chunk 1–{{shown}} ng {{total}}",
    loadMore: "Mag-load pa",
    emptyTitle: "Wala pang chunk",
    emptyBody: "Lalabas dito ang mga chunk kapag tapos na ang pagproseso.",
    noMatchTitle: "Walang tugmang chunk",
    noMatchBody: "Subukan ang ibang salita, o i-clear ang paghahanap.",
    noExcludedTitle: "Walang chunk na hindi kasama",
    noExcludedBody: "Huwag isama ang isang chunk para hindi na ito makuha. Dito lalabas ang mga hindi kasama.",
    clearSearch: "I-clear ang paghahanap",
  },
  editChunk: {
    title: "I-edit ang chunk #{{n}}",
    subtitle: "{{path}} · page {{page}}",
    context: "Kontekstong idinagdag para sa retrieval",
    contextHint: "Ginawa para sa retrieval at idinadagdag bago i-embed. Hindi ipinapakita sa mga user.",
    text: "Teksto ng chunk",
    textRequired: "Hindi puwedeng walang laman ang chunk",
    textTooLong: "Panatilihing mas maikli sa {{max}} na character ang chunk",
    warning: "Nananatili ang manual na edit kapag nag-re-index, pero papalitan kapag nag-upload ng bagong bersyon ng file.",
    save: "I-save at i-re-embed",
    saved: "Na-save ang chunk — na-re-embed at live na sa mga sagot",
  },
  preview: {
    pageOf: "Page {{page}} ng {{total}}",
    highlighted: "Mga chunk sa page na ito: {{chunks}}",
    noChunksOnPage: "Walang na-load na chunk na nagsisimula sa page na ito",
    previous: "Nakaraang page",
    next: "Susunod na page",
    frameTitle: "Page {{page}} ng {{name}}",
    imageAlt: "Page {{page}} ng {{name}}",
    unavailableTitle: "Walang preview ang page na ito",
    unavailableBody: "May preview ang mga page ng PDF at mga na-scan na larawan.",
    noPagesTitle: "Walang preview ng page",
    noPagesBody: "Walang page na mapi-preview ang source na ito. Nasa Mga chunk ang laman nito.",
  },
  questions: {
    emptyTitle: "Dito lalabas ang mga totoong tanong",
    emptyBody: "Mga tanong na sinagot gamit ang source na ito, kasama kung gaano nakatulong ang sagot. {{count}} na sagot na ang bumanggit dito.",
    improve: "Buksan ang Mga Kakulangan sa Kaalaman",
  },
  usage: {
    citations: "Mga citation",
    agents: "Mga agent na gumagamit",
    chunks: "Aktibong chunk",
    tokens: "Na-index na token",
    storage: "Storage",
    generatedQuestions: "Mga nabuong tanong",
    byAgent: "Mga agent",
    noAgents: "I-link ang source na ito sa isang agent para magamit sa pagsagot.",
    trendNote: "Lalabas ang citation kada araw, nangungunang chunk at hati ng channel kapag may kasaysayan na ng paggamit.",
  },
  replace: {
    title: "Palitan ang file",
    body: "Gagawa ng v{{next}} ang pag-upload ng bagong file. Mananatiling live ang v{{current}} hanggang matapos iproseso ang v{{next}}, at puwede mo itong ibalik kahit kailan.",
    queued: "Na-upload — pinoproseso ang v{{version}}",
    unchanged: "Kapareho ng live na bersyon ang file na ito — walang ipoproseso muli",
    infected: "Hinarang ng virus scan ang file na ito",
    failed: "Hindi natapos ang upload. Subukan muli.",
    dropTitle: "I-drop dito ang bagong file, o i-click para pumili",
    dropHint: "PDF, DOCX, XLSX, PPTX, CSV, TXT, MD, JPG/PNG · hanggang 50 MB",
    dragActive: "Bitawan para i-upload",
    rejected: {
      type: "{{name}}: hindi suportado ang ganitong file",
      size: "{{name}}: lampas sa 50 MB",
      empty: "{{name}}: walang laman ang file",
      count: "{{name}}: isang file lang kada upload",
    },
    close: "Isara",
  },
  delete: {
    title: "Burahin ang {{name}}?",
    body_one: "Aalisin ang lahat ng {{chunks}} na chunk at {{versions}} na bersyon sa {{count}} agent. Nabanggit ito sa {{citations}} na sagot — maaaring maging kakulangan sa kaalaman ang mga tanong na iyon.",
    body_other: "Aalisin ang lahat ng {{chunks}} na chunk at {{versions}} na bersyon sa {{count}} na agent. Nabanggit ito sa {{citations}} na sagot — maaaring maging kakulangan sa kaalaman ang mga tanong na iyon.",
    confirm: "Burahin ang dokumento",
    deleted: "Nabura ang {{name}}",
  },
};
